import { Component } from '@angular/core';
import { BaseControlComponent } from '../../../../../../form-controls/components/base-control/base-control.component';
import { ContextInteractionService } from '../../../../../../form-controls/services/context-interaction.service';

@Component({
    selector: 'app-empty-display-config',
    templateUrl: './empty-display-config.component.html',
    standalone: false
})
export class EmptyDisplayConfigComponent extends BaseControlComponent {
    static componentName = 'EmptyDisplayConfigComponent';

    constructor(public readonly contextService: ContextInteractionService) { super(contextService); }
}